import { Pipe, PipeTransform } from '@angular/core';
import * as removeAccents from 'remove-accents';

@Pipe({
    name: 'modalFilterColaborador'
})
export class ModalFilterColaboradorPipe implements PipeTransform {

    transform(value: any, filtroPesquisa?: string, filtroCodigo?: string, filtroNome?: string, filtroCPF?: string, filtroMatricula?: string,
              filtroCentroCusto?: any, filtroUnidade?: any, filtroDepartamento?: any, filtroAplicativo?: string, alterado?: boolean): any {

        let resultFilter = value;
        if (!filtroPesquisa && !filtroCodigo && !filtroNome && !filtroCPF && !filtroMatricula &&
            !filtroCentroCusto && !filtroUnidade && !filtroDepartamento && !filtroAplicativo) {
            return resultFilter;
        } else {
            if (filtroCodigo) {
                resultFilter = resultFilter.filter(s => s.colaboradorId.toLocaleString().toLocaleLowerCase().includes(filtroCodigo.toLocaleLowerCase()) || s.esporadico);
            }
            if (filtroNome) {
                resultFilter = resultFilter.filter(s => removeAccents(s.nome).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroNome).toLocaleLowerCase()) || s.esporadico);
            }
            if (filtroCPF) {
                resultFilter = resultFilter.filter(s => removeAccents(s.documento).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroCPF).toLocaleLowerCase()) || s.esporadico);
            }
            if (filtroMatricula) {
                resultFilter = resultFilter.filter(s => removeAccents(s.matricula).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroMatricula).toLocaleLowerCase()) || s.esporadico);
            }
            if (filtroCentroCusto) {
                if (filtroCentroCusto.length > 0) {
                    resultFilter = resultFilter.filter(s => filtroCentroCusto.some(x => removeAccents(x.ITEM_TEXT).toLocaleLowerCase().includes(removeAccents(s.costCenter).toLocaleLowerCase())) || s.esporadico);
                }
            }
            if (filtroUnidade) {
                if (filtroUnidade.length > 0) {
                    resultFilter = resultFilter.filter(s => filtroUnidade.some(x => removeAccents(x.ITEM_TEXT).toLocaleLowerCase().includes(removeAccents(s.unity).toLocaleLowerCase())) || s.esporadico);
                }
            }
            if (filtroDepartamento) {
                if (filtroDepartamento.length > 0) {
                    resultFilter = resultFilter.filter(s => filtroDepartamento.some(x => removeAccents(x.ITEM_TEXT).toLocaleLowerCase().includes(removeAccents(s.department).toLocaleLowerCase())) || s.esporadico);
                }
            }
            if (filtroAplicativo) {
                resultFilter = resultFilter.filter(s => removeAccents(s.statusApp).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroAplicativo).toLocaleLowerCase()) || s.esporadico);
            }
            if (filtroPesquisa) {
                resultFilter = resultFilter.filter(s => {
                    return (
                        s.colaboradorId.toLocaleString().toLocaleLowerCase().includes(filtroPesquisa) ||
                        removeAccents(s.nome).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                        removeAccents(s.documento).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                        removeAccents(s.matricula).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                        removeAccents(s.nomeCentroCusto).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                        removeAccents(s.nomeUnidade).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                        removeAccents(s.nomeDepartamento).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                        removeAccents(s.statusApp).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase())
                    );
                });
            }
        }
        return resultFilter;
    }

}
